export default __webpack_public_path__ + "static/media/current-assigned-marker.09497664.svg";